import Images from "../assets/images";
import { VfdIcon, ChowdeckIcon, SquareupIcon } from "../assets/svgIcons";
import { pathConstants } from "../routes/pathContants";

const appsData = [
  {
    id: "chowdeck",
    categories: ["Services"],
    imageSrc: <ChowdeckIcon />,
    altText: "Chowdeck",
    appName: "Chowdeck",
    route: pathConstants.APPS_CHOWDECK_CONNECTIONS,
    short_description:
      "Take your restaurant online and start receiving food orders from thousands of hungry customers with chowdeck.",
    status: "pending",
    videoUrl: "",
    url: "https://www.chowdeck.com",
    full_description:
      "Take your restaurant online and start receiving food orders from thousands of hungry customers. With the Chowdeck × Lumi integration, your menu stays in sync, orders are managed directly from Lumi, and delivery is handled by Chowdeck. Grow your reach. Sell more. Stress less.",
    key_features: [
      "Real-time menu and inventory sync between Lumi and Chowdeck.",
      "Orders placed on Chowdeck appear instantly in your Lumi dashboard.",
      "Built-in delivery handled by Chowdeck riders.",
      "No manual updates — set it once on Lumi and you're done.",
      "Tap into Chowdeck's growing customer base and boost your sales.",
    ],
    getting_started: [
      {
        step: "",
        description: "Create your product listings on Lumi",
      },
      {
        step: "",
        description: "Sign up as a restaurant on Chowdeck",
      },
      {
        step: "",
        description: "Connect your Lumi account and map your products.",
      },
      {
        step: "",
        description:
          "Go live, accept orders in Lumi, and let Chowdeck handle delivery",
      },
    ],
    instruction: [
      {
        step: "",
        description: "Go to the Manage Connections tab on Lumi.",
      },
      {
        step: "",
        description: "Connect your Lumi store to your Chowdeck account.",
      },
      {
        step: "",
        description:
          "Map your Lumi products to Chowdeck — inventory syncs automatically.",
      },
      {
        step: "",
        description:
          "Go live and start receiving orders from Chowdeck customers.",
      },
    ],
    app_information: {
      developer: "Chowdeck",
      category: "Food Services",
      pricing_information:
        "Free to use with Lumi subscription. Chowdeck delivery and transaction fees may apply.",
    },
    support: {
      user_guide: "User Guide (coming soon)",
      email: "customerservice@enlumidata.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
  {
    id: "squareup",
    categories: ["Services"],
    imageSrc: <SquareupIcon />,
    altText: "Squareup",
    appName: "Squareup",
    route: pathConstants.APPS_SQUAREUP,
    short_description:
      "Take your restaurant online and start receiving food orders from thousands of hungry customers with Squareup.",
    status: "pending",
    videoUrl: "",
    url: "https://www.squareup.com",
    full_description:
      "Take your restaurant online and start receiving food orders from thousands of hungry customers. With the Squareup × Lumi integration, your menu stays in sync, orders are managed directly from Lumi, and delivery is handled by Squareup. Grow your reach. Sell more. Stress less.",
    key_features: [
      "Real-time menu and inventory sync between Lumi and Squareup.",
      "Orders placed on Squareup appear instantly in your Lumi dashboard.",
      "Built-in delivery handled by Squareup riders.",
      "No manual updates — set it once on Lumi and you're done.",
      "Tap into Squareup's growing customer base and boost your sales.",
    ],
    getting_started: [
      {
        step: "",
        description: "Create your product listings on Lumi",
      },
      {
        step: "",
        description: "Sign up as a restaurant on Squareup",
      },
      {
        step: "",
        description: "Connect your Lumi account and map your products.",
      },
      {
        step: "",
        description:
          "Go live, accept orders in Lumi, and let Squareup handle delivery",
      },
    ],
    instruction: [
      {
        step: "",
        description: "Go to the Manage Connections tab on Lumi.",
      },
      {
        step: "",
        description: "Connect your Lumi store to your Squareup account.",
      },
      {
        step: "",
        description:
          "Map your Lumi products to Squareup — inventory syncs automatically.",
      },
      {
        step: "",
        description:
          "Go live and start receiving orders from Squareup customers.",
      },
    ],
    app_information: {
      developer: "Squareup",
      category: "Food Services",
      pricing_information:
        "Free to use with Lumi subscription. Squareup delivery and transaction fees may apply.",
    },
    support: {
      user_guide: "User Guide (coming soon)",
      email: "customerservice@enlumidata.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },

  {
    id: "Quickteller",
    key: "INTERSWITCH",
    categories: ["Payments"],
    imageSrc: Images.interswitch,
    altText: "Quickteller",
    appName: "Interswitch SmartPOS",
    route:
      pathConstants.APPS_INTEGRATION_BUSINESS_CONNECTION +
      "?terminal_type=INTERSWITCH",
    short_description:
      "Lumi POS processes checkout payments through Interswitch SmartPOS and matches each transaction to the sale, giving you clean, reliable sales records.",
    status: "pending",
    isPaymentIntegration: true,
    videoUrl: "",
    url: "https://interswitchgroup.com/home",
    full_description:
      "Take payments with ease using your Interswitch SmartPOS, now fully integrated with Lumi. You can collect card and bank transfer payments directly from your device, and every transaction is automatically linked to a sale in Lumi. This removes the need for manual reconciliation, reduces errors, and gives you a faster, more secure checkout experience.",
    key_features: [
      "Accept card and transfer payments directly on your POS terminal",
      "Payment instructions are sent instantly from Lumi to the POS",
      "Transactions are verified in real time and matched to the corresponding sale",
      "All completed payments automatically update your sales records",
      "No manual reconciliation or double entry",
      "Easy setup with support for multiple stores from a single Lumi account",
      "Reduces theft by ensuring sales only go through when a valid payment is made",
    ],
    getting_started: [
      {
        step: "",
        description: "Open the *Manage Connections* tab in your Lumi dashboard",
      },
      {
        step: "",
        description:
          "Input your *Merchant ID, **Terminal ID, and **Device Serial Number* from your Quickteller POS device",
      },
      {
        step: "",
        description: "Select the Lumi store you want the device connected to",
      },
      {
        step: "",
        description:
          " Once connected, you are ready to start accepting payments through Quickteller",
      },
    ],
    what_happens_at_checkout: {
      description:
        "When it’s time to collect payment for an order, select either *Card* or *Transfer* as the payment method. Lumi will prompt you to confirm if you would like to use Quickteller Paypoint for the transaction.",
      subHeader: "If you choose Quickteller:",
      contents: [
        "For card payments: The Quickteller POS automatically receives the payment instruction from Lumi. The customer inserts their card and enters their PIN on the device. Once payment is completed, Lumi confirms the transaction and marks the sale as paid.",
        "For bank transfers: The POS will display a one-time account number on the screen. The customer transfers the exact amount to that account. Once Quickteller confirms receipt, Lumi automatically marks the order as paid and completes the sale.",
      ],
    },
    why_use_the_integration: [
      "Every payment is linked to a verified sale, so your records are always accurate",
      "Staff cannot complete a sale unless a real payment has been made",
      "Speeds up checkout, especially during busy hours",
      "Centralised view of all payments and sales in one dashboard",
      "Protects your business from fraud and manual mistakes",
    ],
    app_information: {
      developer: "Interswitch",
      category: "Payment and Fintech Solutions",
      pricing_information:
        "Free to use with Lumi subscription. Transaction fees may be charged by Quickteller for each card or transfer payment.",
    },
    support: {
      user_guide: "User Guide (coming soon)",
      email: "customerservice@enlumidata.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
  {
    id: "Opay",
    key: "OPAY",
    categories: ["Payments"],
    imageSrc: Images.opay,
    altText: "Opay",
    appName: "Opay POS",
    isPaymentIntegration: true,
    route: pathConstants.APPS_INTEGRATION_TERMINALS + "?terminal_type=OPAY",
    short_description:
      "Lumi POS processes checkout payments through Opay POS and matches each transaction to the sale, giving you clean, reliable sales records.",
    status: "pending",
    videoUrl: "",
    url: "https://www.opayweb.com",
    full_description:
      "Take payments with ease using your Opay, now fully integrated with Lumi. You can collect card and bank transfer payments directly from your device, and every transaction is automatically linked to a sale in Lumi. This removes the need for manual reconciliation, reduces errors, and gives you a faster, more secure checkout experience.",
    key_features: [
      "Accept card and transfer payments directly on your POS terminal",
      "Payment instructions are sent instantly from Lumi to the POS",
      "Transactions are verified in real time and matched to the corresponding sale",
      "All completed payments automatically update your sales records",
      "No manual reconciliation or double entry",
      "Easy setup with support for multiple stores from a single Lumi account",
      "Reduces theft by ensuring sales only go through when a valid payment is made",
    ],
    getting_started: [
      {
        step: "",
        description: "Open the *Manage Connections* tab in your Lumi dashboard",
      },
      {
        step: "",
        description:
          "Input your *Merchant ID, **Terminal ID, and **Device Serial Number* from your Quickteller POS device",
      },
      {
        step: "",
        description: "Select the Lumi store you want the device connected to",
      },
      {
        step: "",
        description:
          " Once connected, you are ready to start accepting payments through Quickteller",
      },
    ],
    what_happens_at_checkout: {
      description:
        "When it’s time to collect payment for an order, select either *Card* or *Transfer* as the payment method. Lumi will prompt you to confirm if you would like to use Opay Paypoint for the transaction.",
      subHeader: "If you choose Opay:",
      contents: [
        "For card payments: The Opay POS automatically receives the payment instruction from Lumi. The customer inserts their card and enters their PIN on the device. Once payment is completed, Lumi confirms the transaction and marks the sale as paid.",
        "For bank transfers: The POS will display a one-time account number on the screen. The customer transfers the exact amount to that account. Once Opay confirms receipt, Lumi automatically marks the order as paid and completes the sale.",
      ],
    },

    why_use_the_integration: [
      "Every payment is linked to a verified sale, so your records are always accurate",
      "Staff cannot complete a sale unless a real payment has been made",
      "Speeds up checkout, especially during busy hours",
      "Centralised view of all payments and sales in one dashboard",
      "Protects your business from fraud and manual mistakes",
    ],
    app_information: {
      developer: "Opay",
      category: "Payment and Fintech Solutions",
      pricing_information:
        "Free to use with Lumi subscription. Transaction fees may be charged by Quickteller for each card or transfer payment.",
    },
    support: {
      user_guide: "User Guide (coming soon)",
      email: "customerservice@enlumidata.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
  {
    id: "Moniepoint",
    key: "MONIEPOINT",
    categories: ["Payments"],
    imageSrc: Images.moniepoint,
    altText: "Moniepoint",
    appName: "Moniepoint POS",
    isPaymentIntegration: true,
    route:
      pathConstants.APPS_INTEGRATION_TERMINALS + "?terminal_type=MONIEPOINT",
    short_description:
      "Lumi POS processes checkout payments through Moniepoint POS and matches each transaction to the sale, giving you clean, reliable sales records.",
    status: "pending",
    videoUrl: "",
    url: "https://moniepoint.com",
    full_description:
      "Take payments with ease using your Moniepoint, now fully integrated with Lumi. You can collect card and bank transfer payments directly from your device, and every transaction is automatically linked to a sale in Lumi. This removes the need for manual reconciliation, reduces errors, and gives you a faster, more secure checkout experience.",
    key_features: [
      "Accept card and transfer payments directly on your POS terminal",
      "Payment instructions are sent instantly from Lumi to the POS",
      "Transactions are verified in real time and matched to the corresponding sale",
      "All completed payments automatically update your sales records",
      "No manual reconciliation or double entry",
      "Easy setup with support for multiple stores from a single Lumi account",
      "Reduces theft by ensuring sales only go through when a valid payment is made",
    ],
    getting_started: [
      {
        step: "",
        description: "Open the *Manage Connections* tab in your Lumi dashboard",
      },
      {
        step: "",
        description:
          "Input your *Merchant ID, **Terminal ID, and **Device Serial Number* from your Quickteller POS device",
      },
      {
        step: "",
        description: "Select the Lumi store you want the device connected to",
      },
      {
        step: "",
        description:
          " Once connected, you are ready to start accepting payments through Quickteller",
      },
    ],
    what_happens_at_checkout: {
      description:
        "When it’s time to collect payment for an order, select either *Card* or *Transfer* as the payment method. Lumi will prompt you to confirm if you would like to use Moniepoint Paypoint for the transaction.",
      subHeader: "If you choose Moniepoint:",
      contents: [
        "For card payments: The Moniepoint POS automatically receives the payment instruction from Lumi. The customer inserts their card and enters their PIN on the device. Once payment is completed, Lumi confirms the transaction and marks the sale as paid.",
        "For bank transfers: The POS will display a one-time account number on the screen. The customer transfers the exact amount to that account. Once Moniepoint confirms receipt, Lumi automatically marks the order as paid and completes the sale.",
      ],
    },

    why_use_the_integration: [
      "Every payment is linked to a verified sale, so your records are always accurate",
      "Staff cannot complete a sale unless a real payment has been made",
      "Speeds up checkout, especially during busy hours",
      "Centralised view of all payments and sales in one dashboard",
      "Protects your business from fraud and manual mistakes",
    ],
    app_information: {
      developer: "Moniepoint",
      category: "Payment and Fintech Solutions",
      pricing_information:
        "Free to use with Lumi subscription. Transaction fees may be charged by Quickteller for each card or transfer payment.",
    },
    support: {
      user_guide: "User Guide (coming soon)",
      email: "customerservice@enlumidata.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
  {
    id: "Kuda",
    key: "KUDA",
    categories: ["Payments"],
    imageSrc: Images.kuda,
    altText: "Kuda",
    appName: "Kuda POS",
    isPaymentIntegration: true,
    route: pathConstants.APPS_INTEGRATION_TERMINALS + "?terminal_type=KUDA",
    short_description:
      "Lumi POS processes checkout payments through Kuda POS and matches each transaction to the sale, giving you clean, reliable sales records.",
    status: "pending",
    videoUrl: "",
    url: "https://www.kudaweb.com",
    full_description:
      "Take payments with ease using your Kuda, now fully integrated with Lumi. You can collect card and bank transfer payments directly from your device, and every transaction is automatically linked to a sale in Lumi. This removes the need for manual reconciliation, reduces errors, and gives you a faster, more secure checkout experience.",
    key_features: [
      "Accept card and transfer payments directly on your POS terminal",
      "Payment instructions are sent instantly from Lumi to the POS",
      "Transactions are verified in real time and matched to the corresponding sale",
      "All completed payments automatically update your sales records",
      "No manual reconciliation or double entry",
      "Easy setup with support for multiple stores from a single Lumi account",
      "Reduces theft by ensuring sales only go through when a valid payment is made",
    ],
    getting_started: [
      {
        step: "",
        description: "Open the *Manage Connections* tab in your Lumi dashboard",
      },
      {
        step: "",
        description:
          "Input your *Merchant ID, **Terminal ID, and **Device Serial Number* from your Quickteller POS device",
      },
      {
        step: "",
        description: "Select the Lumi store you want the device connected to",
      },
      {
        step: "",
        description:
          " Once connected, you are ready to start accepting payments through Quickteller",
      },
    ],
    what_happens_at_checkout: {
      description:
        "When it’s time to collect payment for an order, select either *Card* or *Transfer* as the payment method. Lumi will prompt you to confirm if you would like to use Kuda Paypoint for the transaction.",
      subHeader: "If you choose Kuda:",
      contents: [
        "For card payments: The Kuda POS automatically receives the payment instruction from Lumi. The customer inserts their card and enters their PIN on the device. Once payment is completed, Lumi confirms the transaction and marks the sale as paid.",
        "For bank transfers: The POS will display a one-time account number on the screen. The customer transfers the exact amount to that account. Once Kuda confirms receipt, Lumi automatically marks the order as paid and completes the sale.",
      ],
    },

    why_use_the_integration: [
      "Every payment is linked to a verified sale, so your records are always accurate",
      "Staff cannot complete a sale unless a real payment has been made",
      "Speeds up checkout, especially during busy hours",
      "Centralised view of all payments and sales in one dashboard",
      "Protects your business from fraud and manual mistakes",
    ],
    app_information: {
      developer: "Kuda",
      category: "Payment and Fintech Solutions",
      pricing_information:
        "Free to use with Lumi subscription. Transaction fees may be charged by Quickteller for each card or transfer payment.",
    },
    support: {
      user_guide: "User Guide (coming soon)",
      email: "customerservice@enlumidata.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
  {
    id: "paystack",
    isConnected: true,
    categories: ["Payments"],
    imageSrc: Images.paystack,
    altText: "Paystack Payments Gateway",
    appName: "Paystack Payments Gateway",
    short_description:
      "Accept payments on Lumi Business storefront with Paystack.",
    full_description:
      "Integrate Paystack with your Lumi storefront to accept payments via cards, bank transfers, and mobile money. This secure and reliable payment gateway, trusted by businesses across Africa, helps you manage transactions efficiently and offers real-time updates on payments.",
    status: "Connect",
    videoUrl: "SwiclYYKHBQ",
    url: "https://www.paystack.com",
    route: pathConstants.INVENTORY_MENU_PAYMENT,
    key_features: [
      "Accept multiple payment methods (cards, bank transfers, mobile money).",
      "Secure payment processing with PCI DSS Level 1 Compliance.",
      "Real-time transaction alerts and analytics.",
      "Easy setup with Lumi storefront.",
      "User-friendly dashboard for transaction management.",
    ],
    getting_started: [
      {
        step: "Create an Account",
        description:
          "Visit Paystack.com to create a new account or log in to your existing account.",
      },
      {
        step: "Access Your Dashboard",
        description: "After logging in, go to your Paystack dashboard.",
      },
      {
        step: "Locate Your Secret Key",
        description:
          "Navigate to the Settings section on your dashboard. Under API Keys & Webhooks, you'll find your secret key. Copy your secret key.",
      },
      {
        step: "Integrate with Lumi",
        description:
          "In your Lumi dashboard, go to the 'Integrations' tab. Select Paystack and click 'Connect'. Paste your secret key in the designated field on Lumi.",
      },
      {
        step: "Set Up Webhooks",
        description:
          "Generate your webhook URL from the Lumi platform. Copy and paste this URL into the appropriate section on your Paystack dashboard under API Keys & Webhooks.",
      },
      {
        step: "Don’t Have a Paystack Secret Key?",
        description:
          "Visit Paystack.com to get started. Alternatively, watch this short explainer video to guide you through the process.",
      },
    ],
    instruction: [{}],
    app_information: {
      developer: "Paystack",
      category: "Payment Gateway",
      pricing_information:
        "No setup fee, 1.5% + ₦100 per transaction (local), 3.9% + ₦100 (international)",
    },
    support: {
      user_guide: "User Guide",
      email: "support@paystack.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
  {
    id: "stripe",
    isConnected: true,
    categories: ["Payments"],
    imageSrc: Images.stripe,
    altText: "Stripe Payments Gateway",
    appName: "Stripe Payments Gateway",
    route: pathConstants.INVENTORY_MENU_PAYMENT,
    videoUrl: "4fogq7gsBmE",
    url: "https://www.stripe.com",
    short_description:
      "Accept international payments on Lumi Business storefront with Stripe.",
    status: "Connect",
    full_description:
      "Stripe allows you to accept payments from customers worldwide. It’s the go-to choice for businesses looking to expand globally, offering support for multiple currencies and payment methods, all secured by Stripe’s advanced security features and compliance standards.",
    key_features: [
      "Accept payments in over 135 currencies.",
      "Secure payment processing with PCI DSS Level 1 Compliance.",
      "Customizable checkout experience.",
      "Support for recurring billing and subscriptions.",
      "Comprehensive analytics and reporting tools.",
    ],
    getting_started: [
      {
        step: "Video URL",
        description: "Lumi Merchant - Stripe Setup",
      },
      {
        step: "Create an Account",
        description:
          "Visit Stripe.com to create a new account or log in to your existing account",
      },
      {
        step: "Access Your Dashboard",
        description: "After logging in, go to your Stripe dashboard.",
      },
      {
        step: "Locate Your Secret Key",
        description:
          "Navigate to the Developers section on your dashboard. Under the API Keys section, you will find your secret key. Copy your secret key.",
      },
      {
        step: "Integrate with Lumi",
        description:
          "In your Lumi dashboard, go to the 'Integrations' tab. Select Stripe and click 'Connect'. Paste your secret key in the designated field on Lumi.",
      },
      {
        step: "Set Up Webhooks",
        description:
          "Generate your webhook URL from the Lumi platform. Copy and paste this URL into the appropriate section on your Stripe dashboard under Webhooks. Select the necessary events to be sent to your webhook.",
      },
      {
        step: "Don’t Have a Stripe Secret Key?",
        description:
          "Visit Stripe.com to get started. You can also check Stripe’s documentation for detailed setup instructions.",
      },
    ],
    instruction: [{}],
    app_information: {
      developer: "Stripe",
      category: "Payment Gateway",
      pricing_information: "2.9% + 30¢ per successful card charge",
    },

    support: {
      user_guide: "User Guide",
      email: "support@stripe.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },

  {
    id: "vfd",
    isConnected: true,
    categories: ["Payments"],
    imageSrc: <VfdIcon />,
    altText: "Lumi Merchant Account powered by VFD",
    appName: "Lumi Merchant Account powered by VFD",
    route: pathConstants.INVENTORY_MENU_PAYMENT,
    short_description:
      "Open a Lumi -VFD powered current account & accept card and transfer payments with our payment POS terminal.",
    status: "Connect",
    videoUrl: "",
    url: "https://vbank.ng",
    full_description:
      "VFD Microfinance Bank offers businesses an easy way to open a current account and accept payments through their POS terminal. The integration allows you to manage in-store transactions, accepting both card payments and bank transfers with ease. VFD Microfinance Bank provides a robust platform designed to support business growth, offering financial products tailored to small and medium enterprises.",
    key_features: [
      "Open a business current account quickly and easily.",
      "Accept card and bank transfer payments via VFD POS terminals.",
      "Access financial services tailored for businesses.",
      "Real-time transaction tracking and management.",
      "Dedicated customer support.",
    ],
    getting_started: [
      {
        step: "Verify Your Business:",
        description:
          "You will be required to submit KYB documents. Click here to verify your business on Lumi Business.",
      },
      {
        step: "Account Creation:",
        description:
          "A current account will be automatically created for you as soon as you submit your KYB documents. You can also create more sub-accounts using this link: Lumi",
      },
      {
        step: "Set Up POS Terminal:",
        description:
          "You can request for VFD MFM POS terminal from your Lumi business dashboard using this link: POS",
      },
      {
        step: "Start Accepting Payments:",
        description:
          "Once set up, your POS terminal will be delivered to your business address and you can begin accepting card and bank transfer payments.",
      },
    ],
    instruction: [{}],
    app_information: {
      developer: "VFD Microfinance Bank",
      category: "Financial Services",
      pricing_information: "No setup fee, 0.5% capped at N150 per transaction",
    },
    support: {
      user_guide: "User Guide",
      email: "contact@vfdbank.com",
    },
    legal: {
      terms_of_service: "Terms of Service",
      privacy_policy: "Privacy Policy",
    },
  },
];

const keywordMap = {
  "Paystack.com": "https://www.paystack.com",
  "Kuda.com": "https://help.kuda.com",
  "support@paystack.com": "mailto:support@paystack.com",
  "https://www.paystack.com/privacy": "https://www.paystack.com/privacy",
  "https://www.paystack.com/terms": "https://www.paystack.com/terms",
  "Stripe.com": "https://www.stripe.com",
  "Vfdbank.com": "https://vbank.ng",
  "Optimusbank.com": "https://www.optimusbank.com/",
  "chowdeck.com": "https://chowdeck.com/",
  Lumi: "https://app.lumibusiness.io/app/payments/sub-accounts",
  POS: "https://app.lumibusiness.io/app/payments/pos/add",
  Chowdeck: "https://chowdeck.com/vendors",
};

function replaceKeywordsWithLinks(text) {
  const pattern = new RegExp(Object.keys(keywordMap).join("|"), "g");
  return text.replace(pattern, function (matched) {
    return `<a href="${keywordMap[matched]}" target="_blank" rel="noopener noreferrer">${matched}</a>`;
  });
}

appsData.forEach((app) => {
  if (typeof app.description === "string") {
    app.description = replaceKeywordsWithLinks(app.description);
  }

  if (Array.isArray(app.getting_started)) {
    app.getting_started = app.getting_started.map((step) => ({
      ...step,
      description: replaceKeywordsWithLinks(step.description),
    }));
  }

  // if (Array.isArray(app?.instruction)) {
  //   app.instruction = app?.instruction?.map((step) => ({
  //     ...step,
  //     description: replaceKeywordsWithLinks(step?.description),
  //   }));
  // }
});

export default appsData;
